const assets = import.meta.glob('~/assets/images/**/*.*', { eager: true })

export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig()
  const { getImageFluxUrl } = useImageFlux()

  const getAssetUrl = (path: string) => {
    if (!(path in assets)) return path
    const url = (assets[path] as { default: string }).default

    if (!config.app.cdnURL) {
      return url
    }

    const splitPath = path.split('.')
    const extension = splitPath[splitPath.length - 1]

    switch (extension) {
      case 'jpg':
      case 'png':
      case 'gif':
        return getImageFluxUrl({
          path: url.replace(config.public.contentsUrl, ''),
        })
      default:
        return url
    }
  }

  return {
    provide: {
      getAssetUrl,
    },
  }
})
